import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "position-relative p-0" }
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-dark bg-dark px-4 px-lg-5 py-3 py-lg-0" }
const _hoisted_3 = { class: "navbar-brand p-0" }
const _hoisted_4 = { class: "text-primary m-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo"
}, null, -1)
const _hoisted_6 = { class: "navbar-nav ms-auto py-0 pe-4" }
const _hoisted_7 = { class: "nav-item nav-link" }
const _hoisted_8 = { class: "nav-item nav-link" }
const _hoisted_9 = { class: "nav-item nav-link" }
const _hoisted_10 = { class: "nav-item nav-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.getStoreName), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarCollapse",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeShow()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-bars" })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["collapse navbar-collapse", {'show': _ctx.isShow}]),
        id: "navbarCollapse"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("Trang chủ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("a", _hoisted_8, [
            _createVNode(_component_router_link, { to: "/gioi-thieu" }, {
              default: _withCtx(() => [
                _createTextVNode("Giới thiệu")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_router_link, { to: "/san-pham" }, {
              default: _withCtx(() => [
                _createTextVNode("Sản phẩm")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("a", _hoisted_10, [
            _createVNode(_component_router_link, { to: "/lien-he" }, {
              default: _withCtx(() => [
                _createTextVNode("Liên hệ")
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ])
  ]))
}